import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {
  Modal,
  ModalHeader as DefaultModalHeader,
  ModalBody,
  ModalTitle,
  StepRule,
  ExitButton as DefaultExitButton,
} from 'prospect-path-components';
import { connect } from 'react-redux';

import PlanPricingStep from './steps/plan-pricing-step';
import PlanFeaturesSupport from './steps/plan-features-support-step';
import AdditionalNotesStep from './steps/additional-notes-step';

const ModalHeader = styled(DefaultModalHeader)`
  display: flex;
`;

const ExitButton = styled(DefaultExitButton)`
  margin-left: auto;
`;

class PlanModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentStep: 1,
      plan: [],
    };

    this.handleNextButtonClicked = this.handleNextButtonClicked.bind(this);
  }
  handleNextButtonClicked(data) {
    const { plan, currentStep: existingCurrentStep } = this.state;
    const currentStep = existingCurrentStep + 1;

    if (currentStep > 3) {
      this.setState({ plan: { ...plan, ...data }, currentStep: 1 }, () => {
        if (this.props.plan) {
          this.props.onPricingPlanUpdated(this.state.plan);

          return;
        }

        this.props.onPricingPlanAdded(this.state.plan);
      });

      return;
    }

    this.setState({ plan: { ...plan, ...data }, currentStep });
  }
  goToStep(currentStep) {
    this.setState({ currentStep });
  }
  render() {
    return (
      <Modal {...this.props}>
        <ModalHeader>
          <ModalTitle>
            {this.props.plan ? this.props.plan.name : 'New Pricing Plan'}
          </ModalTitle>
          <ExitButton onClick={this.props.closeModal} />
        </ModalHeader>
        <ModalBody>
          <PlanPricingStep
            isOpened={this.state.currentStep === 1}
            disabled={this.state.currentStep !== 1}
            onNextButtonClicked={this.handleNextButtonClicked}
            showEditButton={this.state.currentStep > 1}
            onEditButtonClicked={() => this.goToStep(1)}
            plan={this.props.plan}
            errors={this.props.errors}
            readOnly={this.props.disabled}
          />

          <StepRule />

          <PlanFeaturesSupport
            categories={this.props.categories}
            isOpened={this.state.currentStep === 2}
            disabled={this.state.currentStep !== 2}
            onNextButtonClicked={this.handleNextButtonClicked}
            showEditButton={this.state.currentStep > 2}
            onEditButtonClicked={() => this.goToStep(2)}
            plan={this.props.plan}
            errors={this.props.errors}
            getFeatureDataValues={this.props.getFeatureDataValues}
            readOnly={this.props.disabled}
          />

          <StepRule />

          <AdditionalNotesStep
            isOpened={this.state.currentStep === 3}
            disabled={this.state.currentStep !== 3}
            onNextButtonClicked={this.handleNextButtonClicked}
            plan={this.props.plan}
            errors={this.props.errors}
            readOnly={this.props.disabled}
          />
        </ModalBody>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  pricing: state.productManagement.pricing.all,
});

PlanModal.propTypes = {
  onPricingPlanAdded: PropTypes.func,
  onPricingPlanUpdated: PropTypes.func,
  getFeatureDataValues: PropTypes.func.isRequired,
  categories: PropTypes.array.isRequired,
  errors: PropTypes.object,
  disabled: PropTypes.bool,
};

PlanModal.defaultProps = {
  onPricingPlanAdded: () => {},
  onPricingPlanUpdated: () => {},
  errors: {},
  disabled: false,
};

export default connect(mapStateToProps)(PlanModal);
